export const LOAD_ACTIONABLE_TASKS_SUCCESS = "LOAD_ACTIONABLE_TASKS_SUCCESS";

export const LOAD_ACTIONABLE_TASKS = "LOAD_ACTIONABLE_TASKS";
export const LOAD_ACTIONABLE_TASKS_COUNT = "LOAD_ACTIONABLE_TASKS_COUNT";

export const LOAD_TASK_TYPES = "LOAD_TASK_TYPES";

export const ASSIGN_USERS = "ASSIGN_USERS";
export const ASSIGN_USERS_SUCCESS = "ASSIGN_USERS_SUCCESS";
